import {
  Tags,
  DroneStatus,
  DroneModel,
  // BoundType,
  // BoundStatus,
  PortStatus,
  ProjectStatus,
  GoodStatus,
} from "../generated/graphql";

export interface TagType {
  value: Tags;
  name: string;
}
export interface DroneStatusOptionType {
  value: DroneStatus | string;
  string: string;
  label: string;
}
export interface DroneModelOptionType {
  value: DroneModel | string;
  string: string;
  label: string;
}

export interface PortStatusOptionType {
  value: PortStatus | string;
  string: string;
  label: string;
}
export interface ProjectStatusOptionType {
  value: ProjectStatus | string;
  string: string;
  label: string;
}
export interface GoodStatusOptionType {
  value: GoodStatus | string;
  string: string;
  label: string;
}
export const DroneStatusOption: DroneStatusOptionType[] = [
  { value: ``, string: ``, label: `드론 상태 선택` },
  { value: `Pending`, string: `Pending`, label: `대기` },
  { value: `Operating`, string: `Operating`, label: `운용` },
  { value: `Damage`, string: `Damage`, label: `파손` },
  { value: `Repair`, string: `Repair`, label: `수리` },
  { value: `Testing`, string: `Testing`, label: `테스트` },
];

export const TagList: TagType[] = [
  { value: Tags.Chicken, name: "치킨" },
  { value: Tags.Cafe, name: "카페" },
  { value: Tags.Dessert, name: "디저트" },
  { value: Tags.OutdoorGear, name: "야외놀이 & 필수템" },
  { value: Tags.Safety, name: "안전용품" },
  { value: Tags.Meal, name: "식사" },
  { value: Tags.TodayMeal, name: "오늘의식사" },
  { value: Tags.EventTag, name: "이벤트" },
  { value: Tags.Suggestion, name: `Best추천` },
  // { value: Tags.Emart, name: "이마트" },
  // { value: Tags.GroupPurchase, name: `공동구매` },
  // { value: Tags.Camping, name: `캠핑이벤트` },
  // { value: Tags.LocalFood, name: `로컬푸드` },
  // { value: Tags.EcoFriendly, name: `친환경/유기농` },
  // { value: Tags.Mealkit, name: `밀키트` },
  { value: Tags.NationalFood, name: `전국맛집` },
  { value: Tags.EventProduct, name: `추천특가` },
  { value: Tags.Popularity, name: "인기품목" },
  { value: Tags.Subsidiary, name: "부자재" },

  // { value: Tags.Accessories, name: "패션잡화" },

  // { value: Tags.DeliveryDate, name: `지정일배송` },
  // { value: Tags.NiliGroupPurchase, name: `닐리공구` },
];
export const ProjectStatusOption: ProjectStatusOptionType[] = [
  { value: ``, string: ``, label: `프로젝트 상태` },
  { value: `Pending`, string: `Pending`, label: `준비` },
  { value: `On`, string: `On`, label: `진행` },
  { value: `Completed`, string: `Completed`, label: `완료` },
];
// export const BoundTypeOption: BoundTypeOptionType[] = [
//   { value: ``, string: ``, label: `입고/출고 선택` },
//   { value: `Inbound`, string: `Outbound`, label: `입고` },
//   { value: `Outbound`, string: `Outbound`, label: `출고` },
// ];

// export const BoundStatusOption: BoundStatusOptionType[] = [
//   { value: ``, string: ``, label: `입출고 상태` },
//   { value: `Done`, string: `Done`, label: `완료` },
//   { value: `Gathering`, string: `Gathering`, label: `진행 중` },
// ];
export const PortStatusOption: PortStatusOptionType[] = [
  { value: ``, string: ``, label: `포트 상태` },
  { value: `Pending`, string: `Pending`, label: `대기` },
  { value: `Repair`, string: `Repair`, label: `수리` },
  { value: `Operating`, string: `Operating`, label: `운용` },
];

export const GoodStatusOption: GoodStatusOptionType[] = [
  { value: `Ready`, string: `Ready`, label: `준비` },
  { value: `goodReady`, string: `goodReady`, label: `커밍순` },
  { value: `GoodSales`, string: `GoodSales`, label: `판매중` },
  { value: `SoldOut`, string: `SoldOut`, label: `품절` },
];
export const DroneModelOption: DroneModelOptionType[] = [
  { value: ``, string: ``, label: `드론모델 선택` },
  { value: DroneModel.Phv20, string: `PHV20`, label: `PHV20` },
  { value: DroneModel.Af200, string: `AF200`, label: `AF200` },
  { value: DroneModel.Ds30, string: `DS30`, label: `DS30` },
  { value: DroneModel.P05, string: `P05`, label: `P05` },
  { value: DroneModel.P01, string: `P01`, label: `P01` },
  { value: DroneModel.Pandion, string: `PANDION`, label: `PANDION` },
  { value: DroneModel.Gd23Ot, string: `GD230T`, label: `GD230T` },
];

export interface saveJson {
  typeName: string;
  attrs: ProductAttrTypes[];
}
export interface ProductAttrTypes {
  value: string;
  name: string;
}

export interface AttrInfoSet {
  label?: string;
  value?: string;
}

export interface EditProductProps {
  tabs: number;
  setTabHandler: (tabs: number) => void;
}
export interface EditBannerProps {
  tabs: number;
  setTabHandler: (tabs: number) => void;
}

export interface relatedProps {
  label: string;
  value: number;
}

export interface relatedProps {
  label: string;
  value: number;
}

export interface serviceProps {
  label: string;
  value: number;
}

export interface CouponScope {
  value: string;
  string: string;
  label: string;
}

export const CouponScopeOption: CouponScope[] = [
  {
    value: `LINK_SERVICE`,
    string: `LINK_SERVICE`,
    label: `서비스 지역별`,
  },
  { value: `CORPORATION`, string: `CORPORATION`, label: `매장별` },
  // { value: `GLOBAL`, string: `GLOBAL`, label: `전체 서비스` },
];

export interface CouponStatus {
  value: string;
  string: string;
  label: string;
}

export const CouponStatusOption: CouponStatus[] = [
  { value: `ACTIVE`, string: `ACTIVE`, label: `사용 가능` },
  { value: `INACTIVE`, string: `INACTIVE`, label: `사용 불가` },
  // { value: `EXPIRED`, string: `EXPIRED`, label: `만료` },
];

export interface UserCouponStatus {
  value: string;
  string: string;
  label: string;
}

export enum CouponScopeEnum {
  GLOBAL = "GLOBAL",
  LINK_SERVICE = "LINK_SERVICE",
  CORPORATION = "CORPORATION",
}

export enum CouponStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
